var styles = {"box":"PaginationLocal_box_1n2d8_1","next-btn":"PaginationLocal_next-btn_1n2d8_8","prev-btn":"PaginationLocal_prev-btn_1n2d8_9","v2":"PaginationLocal_v2_1n2d8_15","page":"PaginationLocal_page_1n2d8_15"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
